// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_56-2";
export var blackBorderOnHover = "_56-7";
export var cell = "_56-6";
export var cellContainer = "_56-3";
export var checked = "_56-8";
export var disabled = "_56-5";
export var featuredIconCellContainer = "_56-9";
export var featuredIconTextContainer = "_56-b";
export var featuredIconWrapper = "_56-a";
export var noBorder = "_56-c";
export var orangeSelectedRow = "_cc-3";
export var overflowableText = "_56-0";
export var overflowableTextContainer = "_56-1";
export var row = "_59-0";
export var rowCheckboxCell = "_56-4";
export var selectableTable = "_cc-2";